export default "__VITE_ASSET__YJgg7tqN__"